import type { CampaignCreative } from './campaignsApi';

export const metaReviewLevels = [
  { value: 'unaware', label: 'Inconsciente', description: 'Inconsciente do problema' },
  { value: 'problem_aware', label: 'Dor', description: 'Consciente da dor' },
  { value: 'solution_aware', label: 'Soluções', description: 'Buscando soluções' },
  { value: 'product_aware', label: 'Produto', description: 'Conhece o produto' },
  { value: 'most_aware', label: 'Decisão', description: 'Oferta direta e decisão' },
] as const;

export type MetaReviewLevel = typeof metaReviewLevels[number]['value'];

export function creativeReviewLevel(creative: CampaignCreative): MetaReviewLevel {
  const level = metaReviewLevels.find(level => level.value === creative.consciousnessLevel);
  return level?.value || metaReviewLevels[(creative.stepOrder || 1) - 1]?.value || 'unaware';
}
